"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _ProductImgListCarousel = _interopRequireDefault(require("@sprinx/react-com/ProductImgListCarousel"));

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var _ProductImage = _interopRequireDefault(require("@sprinx/react-com/ProductImage"));

var _ProductPriceElementPriceCvo = _interopRequireDefault(require("../../../components/ProductPriceElementPriceCvo"));

var _usePopulateProductHref = _interopRequireDefault(require("../../../app/AppSettingsProvider/usePopulateProductHref"));

var _ArrowIcon = _interopRequireDefault(require("./ArrowIcon"));

// import ProductDetailGiftsActions from './ProductDetailGiftsActions';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _text;

  return {
    root: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    text: (_text = {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      maxWidth: 620,
      fontSize: 15,
      paddingTop: theme.spacing(2)
    }, (0, _defineProperty2.default)(_text, theme.breakpoints.up('md'), {
      padding: 0
    }), (0, _defineProperty2.default)(_text, "gridArea", 'text'), _text),
    giftContainer: {
      display: 'inline-grid',
      gridTemplateAreas: "'image text'",
      gridTemplateRows: 'auto',
      gridColumnGap: 15,
      alignItems: 'center'
    },
    image: {
      width: 100,
      height: 100,
      gridArea: 'image'
    },
    name: {
      color: theme.palette.primary.main,
      fontSize: 20
    },
    active: {
      color: 'rgba(0,0,0,0.47)'
    },
    description: (0, _extends2.default)({}, theme.typography.body1, {
      marginTop: theme.spacing(1)
    }),
    giftTitle: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 6,
      width: '30%',
      textAlign: 'center',
      padding: theme.spacing(1.5),
      backgroundColor: theme.palette.another.tabs,
      color: theme.palette.common.white,
      marginBottom: theme.spacing(1.5),
      maxWidth: 155
    }, theme.breakpoints.down('sm'), {
      width: '100%',
      maxWidth: 'unset'
    }),
    giftTitleContainer: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    leftButton: {
      transform: 'rotate(180deg)',
      '& svg': {
        height: 30,
        width: 30
      }
    },
    rightButton: {
      '& svg': {
        height: 30,
        width: 30
      }
    },
    content: {
      '&>div': {
        minWidth: '100%'
      }
    }
  };
}, {
  name: 'ProductDetailGifts'
});

function ProductImgListCarouselTitle() {
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: 28,
      fontWeight: 400,
      textTransform: 'uppercase'
    }
  }, t('productGifts/btnName'));
}

var _ref3 = /*#__PURE__*/_react.default.createElement(ProductImgListCarouselTitle, null);

function ProductDetailGifts(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      tabsProps = _ref.tabsProps,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product", "tabsProps"]);
  var _product$adornments = product.adornments,
      adornments = _product$adornments === void 0 ? [] : _product$adornments;

  var _ref2 = adornments.find(function (i) {
    return i.type === 'gifts';
  }) || {},
      _ref2$content = _ref2.content,
      gifts = _ref2$content === void 0 ? [] : _ref2$content;

  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var populateProductHref = (0, _usePopulateProductHref.default)();
  var mediaSizeMap = {
    mini: 'original',
    small: 'original',
    normal: 'original',
    big: 'original'
  };
  return (gifts || []).length === 0 ? null : /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, {
    renderToGridArea: 'gifts'
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), gifts.length > 1 ? /*#__PURE__*/_react.default.createElement(_ProductImgListCarousel.default, {
    autoSlide: true,
    autoSlideInterval: 4000,
    IconLeftComponent: _ArrowIcon.default,
    IconRightComponent: _ArrowIcon.default,
    showNum: 1,
    variant: "on-site" // title={ProductDetailGiftsActions}
    ,
    title: ProductImgListCarouselTitle,
    TitleProps: {
      gifts: gifts
    },
    ComponentProps: {
      classes: {
        leftButton: classes.leftButton,
        rightButton: classes.rightButton,
        content: classes.content
      }
    }
  }, gifts.map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index.toString(),
      className: classes.giftContainer
    }, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
      src: i.image,
      alt: t(i.name),
      classes: {
        root: classes.image,
        image: classes.image
      },
      mediaSizeMap: mediaSizeMap
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.text
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      to: populateProductHref(i).href,
      className: classes.name
    }, t(i.name, {
      acceptString: true
    }), /*#__PURE__*/_react.default.createElement(_ProductPriceElementPriceCvo.default, {
      currency: i.salePriceWithTax[0].currency,
      value: i.salePriceWithTax[0].amount,
      size: "small",
      labelStart: "".concat(t('productGifts/giftValue'), ":")
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.description
    }, t(i.description, {
      acceptString: true
    }))));
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref3, gifts.map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index.toString(),
      className: classes.giftContainer
    }, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
      src: i.image,
      alt: t(i.name),
      classes: {
        root: classes.image,
        image: classes.image
      },
      mediaSizeMap: mediaSizeMap
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.text
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      to: populateProductHref(i).href,
      className: classes.name
    }, t(i.name, {
      acceptString: true
    }), /*#__PURE__*/_react.default.createElement(_ProductPriceElementPriceCvo.default, {
      currency: i.salePriceWithTax[0].currency,
      value: i.salePriceWithTax[0].amount,
      size: "small",
      labelStart: "".concat(t('productGifts/giftValue'), ":")
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: classes.description
    }, t(i.description, {
      acceptString: true
    }))));
  }))));
}

process.env.NODE_ENV !== "production" ? ProductDetailGifts.propTypes = {
  classes: _propTypes.default.shape({
    active: _propTypes.default.string,
    content: _propTypes.default.string,
    description: _propTypes.default.string,
    flexContainer: _propTypes.default.string,
    giftContainer: _propTypes.default.string,
    giftTitle: _propTypes.default.string,
    giftTitleContainer: _propTypes.default.string,
    image: _propTypes.default.string,
    leftButton: _propTypes.default.string,
    name: _propTypes.default.string,
    panel: _propTypes.default.string,
    rightButton: _propTypes.default.string,
    root: _propTypes.default.string,
    tab: _propTypes.default.string,
    tabs: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    adornments: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  }).isRequired,
  tabsProps: _propTypes.default.shape({})
} : void 0;
ProductDetailGifts.defaultProps = {
  classes: undefined,
  className: undefined,
  tabsProps: undefined
};
var _default = ProductDetailGifts;
exports.default = _default;